"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientResourceManager = void 0;
const FileUtils_1 = require("./FileUtils");
/**
 * Currently a wrapper over a map, eventually will also do fetching and own network operations
 */
class ClientResourceManager {
    constructor() {
        this.resourceMap = new Map();
        this.imgMap = new Map();
    }
    storeResource(id, resource) {
        return __awaiter(this, void 0, void 0, function* () {
            this.resourceMap.set(id, resource);
            yield this.load(id);
        });
    }
    getResource(id) {
        if (!this.resourceMap.has(id)) {
            throw Error(`Attempted to fetch non-existant resource: ${id}`);
        }
        // cast here as type inference does not realize this will never return undefined
        return this.resourceMap.get(id);
    }
    getResourceList() {
        return [...this.resourceMap.keys()];
    }
    getImg(name) {
        if (!this.imgMap.has(name)) {
            throw Error(`Attempted to load img for spritesheet not cached: ${name}`);
        }
        // cast here as type inference does not realize this will never return undefined
        return this.imgMap.get(name);
    }
    load(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.imgMap.has(resource)) {
                // throw Error(`Attempted to double load img for resourceID: ${resource}`);
                return; // do nothing, already loaded
            }
            const url = this.getResource(resource).url;
            const img = yield FileUtils_1.createImage(url);
            this.imgMap.set(resource, img);
        });
    }
}
exports.ClientResourceManager = ClientResourceManager;
//# sourceMappingURL=ClientResourceManager.js.map